import React, { FC, useEffect } from 'react'
import { Grid } from "@mui/material";
import "@mozaic-ds/react/lib/index.css";
import "../bundle.scss"
import { Text } from '@mozaic-ds/react';

const SuccesSend: FC = () => {
    useEffect(() => {
        const baseUrl = window.__RUNTIME_CONFIG__?.BASE_MYGOLILLA_URL;
        const timer = setTimeout(() => {
            if (baseUrl) {
                window.location.href = `${baseUrl}/ticket`;
            }
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <Grid item container direction="column" alignItems="center" marginBottom={0}>
                <div style={{ marginTop: "40px" }}>
                    <Text weight="regular" size="xxl">
                        Form inviato con successo, verrai reindirizzato a breve sul portale
                    </Text>
                </div>
                <Grid>
                    <img
                        src="https://static.wixstatic.com/media/2ace76_43a0bc384b9e4317b4105a47d689ea0e~mv2.png/v1/fill/w_515,h_460,fp_0.48_0.55,q_85,usm_0.66_1.00_0.01,enc_auto/image%20(13).png"
                        alt="Servizi Golilla"
                        style={{
                            objectFit: 'cover',
                            objectPosition: '50% 50%',
                    }}
                        loading="lazy"
                    />
                </Grid>
            </Grid>
        </>
    )
};

export default SuccesSend;